import {
  createOptionalFhirDate,
  createReference,
  type WithId,
} from '@quromedical/fhir-common';
import type { DeepPartial } from '@quromedical/utils';
import type * as fhir from 'fhir/r4';
import { mapReferenceToViewModel } from '../domain/mappings';

import { type PractitionerRole, PractitionerRoleSchema } from './schema';

export const mapPractitionerRoleToFhir = (
  item: PractitionerRole,
): WithId<fhir.PractitionerRole> => {
  return {
    resourceType: 'PractitionerRole',
    id: item.id,
    active: item.active,
    location: item.locations.map((location) =>
      createReference('Location', location.id, location.name),
    ),
    organization: createReference(
      'Organization',
      item.organization.id,
      item.organization.name,
    ),
    period: {
      start: createOptionalFhirDate(item.period.start),
      end: createOptionalFhirDate(item.period.end),
    },
    practitioner: createReference(
      'Practitioner',
      item.practitioner.id,
      item.practitioner.name,
    ),
  };
};

export const mapFhirToPractitionerRole = (
  items: WithId<fhir.PractitionerRole>,
): PractitionerRole => {
  const data: DeepPartial<PractitionerRole> = {
    id: items.id,
    active: items.active,
    locations: items.location?.map(mapReferenceToViewModel),
    organization: mapReferenceToViewModel(items.organization),
    period: {
      start: items.period?.start,
      end: items.period?.end,
    },
    practitioner: mapReferenceToViewModel(items.practitioner),
  };

  const parsed = PractitionerRoleSchema.safeParse(data);

  if (!parsed.success) {
    throw parsed.error;
  }

  return parsed.data;
};
